import { Component, OnInit } from '@angular/core';
import { AuthService } from "src/app/shared/services/auth/auth.service";
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
declare var jQuery: any;
declare var $: any;

@Component({
  selector: 'app-shop-cart',
  templateUrl: './shop-cart.component.html',
  styleUrls: ['./shop-cart.component.scss']
})
export class ShopCartComponent implements OnInit {

  is_authenticate_user: boolean = false;
  cartRequest: any = {};
  cartdeleteRequest: any = {};
  //usercartRequest: any = {};
  requantity: any ="";
  user: any = "";
  usercartid: any = "";
  selectedsize: "";
  usercartList: any = "";
  updateqty: any = 0;
  subTotal: any = 0;
  grandTotal: any = 0;
  count: any = 0;
  finalcount: any = 0;
  minimumcharg: any = "";
  shipingcharg: any = 6.00;
  finalcharge : any ="";
  totalItems: any = 0;
  shippingcharge: any = 0;
  remaining: any =0;
  usercartRequest = {
    auth_key: this.user.auth_key
  };
  

  constructor(
    private activatedRoute: ActivatedRoute,
    public authService: AuthService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.loadcart();

    this.authService.$user.subscribe((data) => {
      console.log("login j chhhhe");
      console.log(data);
      if (data) {
        this.user = data;
      } else {
        this.user = null;
      }
    });



  }

  loadcart() {
    if (this.authService.isLoggedIn == true) {
    this.subTotal = 0;
    let request = Object.assign({}, this.usercartRequest);
    this.authService.getUsercart(request).then((res) => {
      this.usercartList = res.data;
      console.log(this.usercartList);
      this.usercartList.forEach((cart) => {
        cart.itemTotal = parseInt(cart.amount) * parseInt(cart.quantity);
        //cart.itemshipping += parseInt(this.count + 1) * parseInt(cart.quantity);
        this.subTotal = parseInt(this.subTotal) + parseInt(cart.itemTotal);
        this.count++;
       console.log(this.count);
        //console.log(this.subTotal);
        // this.ordercart += cart.user_cart_id + ",";
      });
      this.totalItems = this.usercartList.length;
      if(this.usercartList.length > 0){
        if(this.usercartList.length == 1){
          this.shipingcharg = 6.0;
        }else{
          this.remaining = parseInt(this.usercartList.length) - 1;
          this.shipingcharg = parseInt(this.remaining) * 0.5;
          this.shipingcharg = parseFloat(this.shipingcharg) + 6.0;
        }
      }
      console.log("shipping"+this.shipingcharg);
      this.grandTotal = parseInt(this.subTotal) + parseFloat(this.shipingcharg);
      console.log("grnadtyotla"+this.grandTotal);
    }).catch((err) => {
      //console.log(err);
    });
    } else {
      this.router.navigate(['/login']);
    }
  }

  incrementquantity(id: any){
    
    var storesub = jQuery('#subtotal').val();
    var dataid = id;
    this.usercartid = dataid;
    var qtyval = jQuery("#quantity" + dataid).val();
    var prival = jQuery("#price" + dataid).val();
    qtyval = parseInt(qtyval) + 1;
    this.updateqty = qtyval;
    
    this.requantity = qtyval;
    jQuery("#quantity" + dataid).val(qtyval);
    jQuery('#pPrice' + dataid).html('£ ' + qtyval * prival + '');
   
    this.update_to_cart();
   
   
    
  }

  decrementquantity(id: any){    
         var dataid = id;
          this.usercartid = dataid;
          var qtyval = jQuery("#quantity" + dataid).val();
          var prival = jQuery("#price" + dataid).val();
          this.requantity = qtyval;
          if (qtyval > 1) {
            qtyval = parseInt(qtyval) - 1;
            this.updateqty = qtyval;
            jQuery("#quantity" + dataid).val(qtyval);
            jQuery('#pPrice' + dataid).html('£ ' + qtyval * prival + '');
           
          }
          this.update_to_cart();
         
  }

  sizeaction(id: any) {
    this.usercartid = id;
    this.selectedsize = jQuery("#select_size" + id).val();

    // this.cartRequest = {       
    //   auth_key: this.user.auth_key,
    //   user_cart_id: this.usercartid,
    //   product_size_master_id: this.selectedsize,
    //   quantity: this.requantity
    // };
    this.update_to_cart();
    //this.loadcart();

  }

  update_to_cart() {
    if (this.authService.isLoggedIn == true) {

      this.is_authenticate_user = true;
      this.cartRequest = { 
        auth_key: this.user.auth_key,
        user_cart_id: this.usercartid,
        product_size_master_id: this.selectedsize,
        quantity: this.updateqty
      };
     
      let request: any = {
      };
      request = Object.assign({}, this.cartRequest);
      this.authService.addUserCart(request).then(
        (res) => {
          if (res.status == 1) {
            this.loadcart();
           // this.router.navigate(['/shop-cart']);
          }
          //console.log(res.data);
          /*this.addedtocartPopup();*/
        }).catch((err) => {
          //console.log(err);
        });
    } else {
      this.router.navigate(['/login']);
    }
  }

  delete_detail(cartid: any) {
    var checkstr = confirm('Are you sure you want to delete this?');
    if (checkstr == true) {
      this.cartdeleteRequest = {
        auth_key: this.user.auth_key,
        user_cart_id: cartid,

      };
      let request: any = {
      };
      request = Object.assign({}, this.cartdeleteRequest);
      this.authService.deletecart(request).then(
        (res) => {

          if (res.status == 0) {

          } else {
            this.loadcart();
          }

          //this.loadcart();
        }).catch((err) => {
          //console.log(err);
        });
    } else {
      return false;
    }

  }

  


}
